import { TimeTracking } from '../models/timeTracking';

export function getFromToPauseValues(timeTracking: TimeTracking) {
  return {
    from:
      timeTracking.correctedFrom !== undefined
        ? timeTracking.correctedFrom
        : timeTracking.from,
    to:
      timeTracking.correctedTo !== undefined
        ? timeTracking.correctedTo
        : timeTracking.to,
    pause:
      timeTracking.correctedPause !== undefined
        ? timeTracking.correctedPause
        : timeTracking.pause,
  };
}
